import type { PermissionCode } from "@koclukpanel/authz";

/**
 * PANELDE İZİN SORMA — TEK KAPI
 *
 * ================================================================
 * NEDEN VAR: YAZIM HATASI SESSİZCE `false` DÖNÜYORDU
 * ================================================================
 * Panelde yirmi üç yerde `"kisi.veli.bagla" in ben.izinler` gibi elle
 * yazılmış izin dizgisi vardı ve hiçbiri korunmuyordu. Yanlış yazılan
 * bir kod hata vermiyor, sessizce `false` dönüyor: düğme hiç
 * görünmüyor, kimse sebebini aramıyor.
 *
 * 05.09.2026'da tarandı ve **bir tane** çıktı:
 * `Uygulama.tsx` içinde `"program.hafta.duzenle"` — katalogda böyle bir
 * izin YOK (`program.hafta.olustur` / `.yayinla` / `.onayla` var).
 * O satır bir yıl boyunca hep `false` döndü.
 *
 * ================================================================
 * TİP NE ÇÖZÜYOR, NE ÇÖZMÜYOR
 * ================================================================
 * `PermissionCode` yalnızca "böyle bir izin VAR MI" sorusunu
 * cevaplıyor. "DOĞRU izin mi" sorusunu cevaplamıyor: bir düğmeyi
 * katalogda gerçekten bulunan ama YANLIŞ bir izne bağlamak hâlâ
 * mümkün ve derleyici bir şey demez.
 *
 * O ikinci soru ancak düğmenin çağırdığı ucun dekoratörüyle
 * karşılaştırılarak cevaplanır; `izin-tarama.test.ts` bunun
 * ölçülebilen kısmını ölçüyor.
 *
 * ================================================================
 * NEDEN FONKSİYON, NEDEN HAM HARİTA DEĞİL
 * ================================================================
 * `ben.izinler` sunucudan `Record<string, string>` olarak geliyor —
 * anahtar izin kodu, değer kapsam. Ham hâliyle dolaştırmak, her
 * çağrı yerinde yeniden dizgi yazmak demek. Fonksiyon, dizgiyi TEK
 * yerde tipe bağlıyor.
 */
export type IzinHaritasi = Record<string, string>;

/** Bu izin var mı — yazım hatası DERLENMİYOR. */
export function izinVarMi(izinler: IzinHaritasi, kod: PermissionCode): boolean {
  return kod in izinler;
}

/**
 * Verilenlerden EN AZ BİRİ var mı.
 *
 * Menü öğeleri ve sekmeler "şu ya da bu" diyor: bir ekranın işini iki
 * ayrı rol yapıyor ve ikisi aynı izni taşımıyor olabilir (`Kabuk.tsx`
 * `izin` alanının notu bunun üç örneğini sayıyor).
 */
export function biriVarMi(izinler: IzinHaritasi, kodlar: readonly PermissionCode[]): boolean {
  return kodlar.some((k) => k in izinler);
}

/**
 * İznin KAPSAMI — `"ALL"`, `"ASSIGNED"`, … ya da izin yoksa `null`.
 *
 * Bazı ekranlar varlığı değil kapsamı soruyor: başkasının etkinlik
 * dökümünü açmak `ALL` istiyor, dar kapsamlı biri o düğmeyi açtığında
 * her seferinde 403 alırdı.
 */
export function izinKapsami(izinler: IzinHaritasi, kod: PermissionCode): string | null {
  return izinler[kod] ?? null;
}

/**
 * Bir izin haritasını sorgulayan kapalı fonksiyon.
 *
 * `Uygulama.tsx` yirmiye yakın yerde aynı haritaya soruyor; her
 * seferinde haritayı yeniden vermek gürültü olurdu. `Ogrenci360` da
 * sekmelere bunu geçiriyor.
 */
export function izinSorgusu(izinler: IzinHaritasi): (kod: PermissionCode) => boolean {
  return (kod) => kod in izinler;
}
